// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPriceBaseResponse

export type WidgetBookingPriceBaseApiResponse = {
	name: string;
	price: number;
};

export type WidgetBookingPriceBase = {
	name: string;
	price: number;
};

export function hydrateWidgetBookingPriceBase(data: WidgetBookingPriceBaseApiResponse): WidgetBookingPriceBase {
	return { ...data };
}